import Admin2 from 'layouts/Admin2';

// Older portal screens keep their actions and filters in the shared workspace.
export default function Admin({ children, pageTitle, headerContent, filters }) {
    return <Admin2 pageTitle={pageTitle} pageActions={headerContent}>
        {filters && <div className="portal-filter-bar">{filters}</div>}
        {children}
    </Admin2>;
}
